import { BodyText, Flex, theme } from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const StyledLeasingTypeContainer = styled(Flex)`
  width: 100%;
  height: 3.5rem;

  align-items: flex-end;
  justify-content: center;
  padding-right: 2rem;

  background-color: ${theme.colors.primaryT2};
`;

export const StyledLeasingType = styled(BodyText)`
  color: ${theme.colors.primaryW};
  text-transform: uppercase;
  margin: 0;
`;

export const StyledTitleContainer = styled(Flex)`
  width: 100%;
  justify-content: space-between;

  margin-bottom: 1rem;

  ${mediaQuery('md')} {
    flex-direction: row;
  }
`;

export const StyledOfferNumber = styled.span`
  text-transform: none;
`;

export const StyledOfferOverviewTextContainer = styled.div`
  margin-top: 3.125rem;
  width: 100%;
  white-space: break-spaces;
  text-align: justify;
`;

export const StyledText = styled(BodyText)<{
  accented?: boolean;
}>`
  color: ${(props) => (props.accented ? theme.colors.primaryT1 : 'initial')};
`;

export const StyledConsultantInfoContainer = styled(Flex)`
  margin-top: 3.125rem;

  ${BodyText} {
    margin: 0;
  }
`;
